import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import SelectBox from "./SelectBox";
import CheckCross from "../../common/AppTable/CheckCross";
import { TableActionGroup } from "../../common/Buttons";
import { referenceRenderer, redirectToReferenceNode, formatDueDate } from "./Uitlities";
import { useNavigate } from "react-router-dom";
import Loader from "../../common/Loader";

const AddEditRow = ({
  taskInfo,
  handleAddEditRow,
  inputState,
  action = null,
  delTask,
  reference,
  closePopup,
  setPreviusTaskInfo,
  reassign_persmision,
  isAnyOperationActive = false,

  //Show User Highlight
  showUserHighlight = false,
  hilightedUserId = null,
}) => {

  const { users } = useSelector((state) => state.users);

  const processedUsers = React.useMemo(() => {
    return (users.filter(u => u.email !== "system@task.com") || []).map(u => {
      if (String(u.status).toLowerCase() === 'disabled') {
        return {
          ...u,
          name: `${u.name} (disabled)`,
          style: { color: 'gray' },
          disabled: true
        };
      }
      return u;
    });
  }, [users]);
  const { taskReference } = useSelector((state) => state.task);
  const isEditing = action === "edit" ? true : false;
  const { task_tree_node_id_ref } = taskReference || {};

  const [isSelecting, setIsSelecting] = useState(false);

  const handleFieldChange = (e) => {
    let input = e.target;
    inputState((prev) => ({ ...prev, [input.name]: input.value }));
  };

  const currentUserId = localStorage.getItem("user_id");
  const isOwner = taskInfo?.owned_by?.toString() === currentUserId?.toString();
  const canDelete = (reassign_persmision || isOwner) && (taskInfo?.status === "COMPLETED" || taskInfo?.status === "CANCELLED");
  const isAssignee = taskInfo?.assign_to?.toString() === currentUserId?.toString();
  const canEdit = (reassign_persmision || isOwner || isAssignee) && (taskInfo?.status !== "COMPLETED" && taskInfo?.status !== "CANCELLED"); // Owner or assignee can edit
  const isAssigneeOnly = isAssignee && (!isOwner && !reassign_persmision); // Assignee but not owner and no reassign permission

  // Status options for assignees (limited)
  const assigneeStatusOptions = ["OPEN", "PENDING", "WAITING", "IN PROGRESS"];
  // All status options for owners
  const allStatusOptions = [
    "OPEN",
    "PENDING",
    "IN PROGRESS",
    "WAITING",
    "STOPPED",
    "COMPLETED",
    "CANCELLED",
    "ASSIGNED",
  ];

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading } = useSelector((state) => state.task);

  let taskreference = ""

  const renderUser = (user, userId) => {
    const name = user ? user.first_name + " " + user.last_name : "";
    const isDisabled = user && String(user.status).toLowerCase() === 'disabled';
    const isHighlighted = showUserHighlight && userId === hilightedUserId;

    if (isHighlighted || isDisabled) {
      return <span style={{ color: "red" }}>{name}{isDisabled ? " (disabled)" : ""}</span>
    }
    return name;
  };

  if (isEditing || action === null) {
    taskreference = referenceRenderer(taskInfo);
  }
  if (action === null) {
    taskreference = referenceRenderer(taskInfo);
    return (
      <>
        {isSelecting && <Loader text="Loading reference..." />}
        <tr>
          <td>
            <input
              type="checkbox"
              checked={taskInfo.is_pinned || false}
              disabled={true}
              readOnly={true}
            />
          </td>
          <td>{taskreference}</td>
          <td>{taskInfo.tags}</td>
          <td>{taskInfo.task}</td>
          <td>{taskInfo.note}</td>
          <td>{taskInfo.status}</td>
          <td>{taskInfo.progress}</td>
          <td>{formatDueDate(taskInfo.due)}</td>
          <td>{taskInfo.remind}</td>
          <td>{taskInfo.escalate}</td>
          <td>{taskInfo.created_at?.split("T")[0]}</td>
          <td>
            {renderUser(taskInfo.assigned_user, taskInfo.assign_to)}
          </td>
          <td>
            {renderUser(taskInfo.owned_by_user, taskInfo.owned_by)}
          </td>
          <td>
            <TableActionGroup
              mode="view"
              showEdit={true}
              showDelete={true}
              showSelect={true}
              disableEdit={!canEdit || isAnyOperationActive}
              disableDelete={!canDelete || isAnyOperationActive}
              disableSelect={
                taskInfo.procedure_tree?.tree_node_id?.toLowerCase() ===
                  task_tree_node_id_ref?.toLowerCase() || isAnyOperationActive
              }
              onEdit={() => {
                inputState(taskInfo)
                setPreviusTaskInfo({
                  ...taskInfo,
                  reference: taskreference,
                  encoded_reference: taskInfo.reference
                })
              }}
              onDelete={() => delTask(taskInfo.task_id, taskInfo.task, taskInfo.status, taskInfo.owned_by)}
              onSelect={async () => {
                setIsSelecting(true);
                try {
                  let url = await redirectToReferenceNode(taskInfo, dispatch);
                  navigate(url);
                  if (closePopup) closePopup();
                } catch (error) {
                  console.error("Error redirecting to reference node:", error);
                  setIsSelecting(false);
                }
              }}
            />
          </td>
        </tr>
      </>
    );
  } else {

    return (
      <tr>
        <td>
          <input
            type="checkbox"
            name="is_pinned"
            defaultChecked={isEditing ? (taskInfo.is_pinned || false) : false}
            onChange={(e) => {
              inputState((prev) => ({ ...prev, is_pinned: e.target.checked }));
            }}
            disabled={isAssigneeOnly}
          />
        </td>
        <td>
          {isEditing ? taskreference : reference}
        </td>
        <td>
          <input
            className="app-input"
            style={{  }}
            name="tags"
            defaultValue={isEditing ? taskInfo.tags : ""}
            onChange={handleFieldChange}
            disabled={isAssigneeOnly}
            readOnly={isAssigneeOnly}
          />
        </td>
        <td>
          <input
            className="app-input"
            style={{  }}
            name="task"
            defaultValue={isEditing ? taskInfo.task : ""}
            onChange={handleFieldChange}
            disabled={isAssigneeOnly}
            readOnly={isAssigneeOnly}
          />
        </td>
        <td>
          <input
            className="app-input"
            style={{  }}
            name="note"
            defaultValue={isEditing ? taskInfo.note : ""}
            onChange={handleFieldChange}
          />
        </td>
        <td>
          <SelectBox
            data={isAssigneeOnly ? assigneeStatusOptions : allStatusOptions}
            simple={true}
            keySuffux="status"
            fieldProps={{
              name: "status",
              defaultValue: isEditing ? taskInfo.status : "",
              onChange: handleFieldChange,
            }}
          />
        </td>
        <td>
          <input
            type="number"
            className="app-input"
            name="progress"
            min="0"
            max="100"
            onKeyDown={(e) => {
              if (["e", "E", "+", "-", "."].includes(e.key)) {
                e.preventDefault();
              }
            }}
            onPaste={(e) => {
              e.preventDefault();
              const pasted = (e.clipboardData?.getData("text") || "").replace(/[^\d]/g, "");
              const num = parseInt(pasted, 10);
              if (!Number.isNaN(num)) {
                const clamped = Math.min(100, Math.max(0, num));
                const str = String(clamped);
                e.target.value = str;
                inputState((prev) => ({ ...prev, progress: str }));
              }
            }}
            onChange={(e) => {
              let val = parseInt(e.target.value, 10);
              if (Number.isNaN(val) || val < 0) val = 0;
              if (val > 100) val = 100;
              e.target.value = val;
              inputState((prev) => ({ ...prev, progress: val }));
            }}
            defaultValue={taskInfo?.progress ?? 0}
          />
        </td>
        <td>
          <input
            type="date"
            className="app-input"
            name="due"
            style={{width: "115px"}}
            onChange={handleFieldChange}
            defaultValue={isEditing ? formatDueDate(taskInfo.due) : ""}
            disabled={isAssigneeOnly}
            readOnly={isAssigneeOnly}
          />
        </td>
        <td>
          <input
            type="number"
            className="app-input no-spinners"
            name="remind"
            min="0"
            onKeyDown={(e) => {
              if (["e", "E", "+", "-", "."].includes(e.key)) {
                e.preventDefault()
              }
            }}
            onChange={handleFieldChange}
            defaultValue={taskInfo?.remind ?? 0}
            disabled={isAssigneeOnly}
            readOnly={isAssigneeOnly}
          />
        </td>
        <td>
          <input
            type="number"
            className="app-input no-spinners"
            name="escalate"
            min="0"
            onKeyDown={(e) => {
              if (["e", "E", "+", "-", "."].includes(e.key)) {
                e.preventDefault() 
              }
            }}
            onChange={handleFieldChange}
            defaultValue={taskInfo?.escalate ?? 0}
            disabled={isAssigneeOnly}
            readOnly={isAssigneeOnly}
          />
        </td>
        <td>
          {isEditing ? taskInfo.created_at?.split("T")[0] : new Date().toISOString().split("T")[0]}
        </td>
        <td>
          {/* If the Owned by, Assigned to, and any other dropdown field is disabled then remove then down arrow icon from the field. */}
          <SelectBox
            value="id"
            text="name"
            data={processedUsers}
            keySuffux="assignedto"
            fieldProps={{
              name: "assign_to",
              onChange: handleFieldChange,
              defaultValue: isEditing ? taskInfo.assign_to : "",
              disabled: isAssigneeOnly,
            }}
          />
        </td>
        <td>
          {/* If the Owned by, Assigned to, and any other dropdown field is disabled then remove then down arrow icon from the field. */}
          {(()=>{
            if(action === "edit" && taskInfo.task_type === "system-generated"){
              return renderUser(taskInfo.owned_by_user,taskInfo.owned_by)
            }else{
              return <SelectBox
                value="id"
                text="name"
                data={processedUsers}
                keySuffux="ownedby"
                fieldProps={{
                  name: "owned_by",
                  onChange: handleFieldChange,
                  defaultValue: isEditing ? taskInfo.owned_by : (action === "add" ? currentUserId : ""),
                  disabled: isEditing && !reassign_persmision
                }}
              />
            }
          })()}
        </td>
        <td>
          <CheckCross
            handleAddEditRow={handleAddEditRow}
            handleCancel={() => inputState(null)}
            loading={loading}
          />
        </td>
      </tr>
    );
  }
};

export default AddEditRow;
